/** @jsx jsx */
import { jsx, Grid, Box, Link, Flex, Text } from 'theme-ui';
import React, { useState } from 'react';
import { ethers } from 'ethers';
import './App.css';
import './global.css';
import { products } from './data/products-json';
import { useExchangePrice, useCustomContractReader, useCustomContractLoader } from './hooks';
import theme from './theme';
import { ThemeProvider } from 'theme-ui';
import TextWrapper from './components/TextWrapper';

//main components
import Account from './components/Account';
import Nav from './components/Nav';

import Footer from './components/Footer';

// page components
import Vote from './VoteNew.js';
import TimeReport from './TimeReportCountdown';
import VoteReport from './VoteReport';

/// CHANGE THIS TO YOUR INFURA ID
const mainnetProvider = new ethers.providers.InfuraProvider('mainnet', '0f81cfb01c1c40afb8ac9e2698ca98a9');
const localProvider = mainnetProvider; //new ethers.providers.JsonRpcProvider(process.env.REACT_APP_PROVIDER?process.env.REACT_APP_PROVIDER:"http://localhost:8545")

function App() {
	const [ address, setAddress ] = useState();
	const [ loading, setLoading ] = useState(true);
	const [ injectedProvider, setInjectedProvider ] = useState();
	const [ isLoading, output ] = useState();
	const price = useExchangePrice(mainnetProvider);

	//SWAGG details

	const ERC20 = [
		{
			inputs: [
				{
					internalType: 'address',
					name: 'account',
					type: 'address'
				}
			],
			name: 'balanceOf',
			outputs: [
				{
					internalType: 'uint256',
					name: '',
					type: 'uint256'
				}
			],
			stateMutability: 'view',
			type: 'function'
		}
	];
	//useCustomContractLoader(provider,contractName,address)
	const SwaggTokenContract = useCustomContractLoader(
		mainnetProvider,
		'SWAGG',
		'0xa19A40FbD7375431fAB013a4B08F00871B9a2791',
		ERC20
	);
	//const alexBalance = useContractReader(props.contracts,props.name,"balanceOf",[props.address],1777);
	const SwaggBalance = useCustomContractReader(SwaggTokenContract, 'balanceOf', [ address ], 1777, (hex) => {
		return hex.toNumber() / 10 ** 4;
	});

	return (
		<ThemeProvider theme={theme}>
			<Box variant="boxes.global">
				<Nav />
				<TextWrapper sx={{ pt: [ 'l', null, 'l' ] }}>
					<Text variant="vote.l" mb="xl" sx={{ display: [ 'none', 'block' ] }} className="text-grad tsf">
						Collective<br /> Curation pt-01
					</Text>
					<Text variant="vote.s" mb="l">
						Use $SWAGG to help me pick the best design for the upcoming <br />Kôdè "Heritage" Collection
						PT-01.
						{/* Vote for your favorite design on the upcoming Kôdè "Heritage" Collection */}
						<br />
						The Vote is Onchain.&nbsp;Gasless.&nbsp;Secure.&nbsp;Decentralized
					</Text>
					<Account
						address={address}
						setAddress={setAddress}
						localProvider={localProvider}
						injectedProvider={injectedProvider}
						setInjectedProvider={setInjectedProvider}
						mainnetProvider={mainnetProvider}
						price={price}
					/>
					<p
						sx={{
							fontFamily: 'sans',
							fontSize: 'fs12',
							mt: 'm'
						}}
						className="text-grad-green tsf"
					>
						Your holdings: &nbsp;{SwaggBalance} $SWAGG =&nbsp;{SwaggBalance} votes
					</p>
				</TextWrapper>

				<Vote
					address={address}
					injectedProvider={injectedProvider}
					localProvider={localProvider}
					SwaggBalance={SwaggBalance}
				/>

				<TextWrapper sx={{ pt: [ 'xl', null, 'xl' ], pb: 'xl' }}>
					<TimeReport mainnetProvider={mainnetProvider} />
					{/* 	<VoteReport /> */}
				</TextWrapper>
				<hr />

				<TextWrapper sx={{ pt: [ 'l', null, 'l' ], pb: 'xxxxl', maxWidth: '500px' }}>
					<Text variant="vote.s" mb="s">
						How it works?
					</Text>

					<Text>
						1. Get some $SWAGG on{' '}
						<a
							href="https://uniswap.exchange/swap?outputCurrency=0xa19A40FbD7375431fAB013a4B08F00871B9a2791"
							alt="carlos"
							target="_blank"
						>
							Uniswap
						</a>
						<br />
						2. Vote on your favorite design (gasless, just need to sign the transaction)<br />
						3. The first 15 valid votes earn $SWAGG airdrop <br />
						4. The top 3 winning designs will be announced when the voting period ends and selected to be
						part of the upcoming Kôdè "Heritage" Collection".<br />
						<br />
						5. One $SWAGG, one vote. <br />The more you own, the more votes you can cast.
					</Text>
					<br />
					<hr />
					<br />
					{/* <span className="loading star" /> */}
					<Text variant="vote.s" mb="s">
						What is Kôdè?
					</Text>

					<Text>
						Kôdè is a #nofilter conceptual personal brand by{' '}
						<a href="https://twitter.com/carlosecgomes" alt="carlos" target="_blank">
							Carlos.&nbsp;
						</a>
						It will be a series of creations & collaboration around my personality, heritage and street
						culture. {/* It will be fun. */}
						{/* Most importantly kôdè is a continuos experiement around culture of art, ownership and distribution. */}
						<br />
					</Text>
					<br />
					<Text variant="vote.s" mb="s">
						When will the collection be available?
					</Text>

					<Text>
						The collection will be available in the upcoming weeks. All items will be also represented by a
						tradeble token. <br />More details soon.
						<br />
					</Text>
					<br />
					<Text variant="vote.s" mb="s">
						Why $SWAGG?
					</Text>
					<Text>
						$SWAGG is my personal token powered by{' '}
						<a href="https://tryroll.com" alt="Roll" target="_blank">
							Roll.
						</a>
						<br />
						It's an experiment around social money, brand ownership and collective creativity. <br />
						<a href="https://getswagg.com/" alt="getswagg" target="_blank">
							Learn more here
						</a>
					</Text>
					<br />
					<Text variant="vote.s" mb="s">
						Why community vote?
					</Text>
					<Text>
						Community vote through $SWAGG was inspired by recent{' '}
						<a
							href="https://twitter.com/AlexMasmej/status/1272538787755810817"
							title="ALEX"
							target="_blank"
						>
							#ALEX ‘Control My Life’
						</a>{' '}
						voting initiative and based on the amazing scaffoldeth project by<a
							href="https://twitter.com/austingriffith"
							title="Austin Griffith"
							target="_blank"
						>
							&nbsp;Austin Griffith.
						</a>
						<br />
						<br />
						<br />
						<span className="loading star" />
					</Text>

					<br />
				</TextWrapper>
				<Footer />
			</Box>
		</ThemeProvider>
	);
}

export default App;
